import { brandfolderColorPalette } from '@brandfolder/react';
import { Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${brandfolderColorPalette.neutrals[300]};
  margin-bottom: 24px;
  width: fit-content;
`;

const Tab = styled.button<{ isActive: boolean }>`
  background: none;
  border: none;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  cursor: pointer;
  color: ${({ isActive }): string =>
    isActive ? brandfolderColorPalette.primary[600] : brandfolderColorPalette.neutrals[600]};
  border-bottom: 2px solid ${({ isActive }): string =>
    isActive ? brandfolderColorPalette.primary[600] : 'transparent'};
  transition: all 0.2s ease;

  & > span {
    color: ${({ isActive }): string =>
    isActive ? brandfolderColorPalette.primary[600] : brandfolderColorPalette.neutrals[500]};
  }

  &:hover {
    color: ${brandfolderColorPalette.primary[600]};
    background-color: ${brandfolderColorPalette.neutrals[100]};
  }

  &:focus {
    outline: 2px solid ${brandfolderColorPalette.primary[200]};
    outline-offset: 2px;
  }
`;

const Count = styled.span`
  margin-left: 8px;
  font-weight: normal;
`;

export type PeopleManagementFilterType = 'all' | 'named' | 'unnamed';

interface PeopleManagementFilterProps {
  activeFilter: PeopleManagementFilterType;
  onFilterChange: (filter: PeopleManagementFilterType) => void;
  allCount: number;
  namedCount: number;
  unnamedCount: number;
}

export const PeopleManagementFilter: FunctionComponent<PeopleManagementFilterProps> = ({
  activeFilter,
  onFilterChange,
  allCount,
  namedCount,
  unnamedCount
}) => {
  return (
    <TabsContainer>
      <Tab
        isActive={activeFilter === 'all'}
        onClick={() => onFilterChange('all')}
      >
        <Trans>All</Trans>
        <Count>{allCount}</Count>
      </Tab>
      <Tab
        isActive={activeFilter === 'named'}
        onClick={() => onFilterChange('named')}
      >
        <Trans>Named</Trans>
        <Count>{namedCount}</Count>
      </Tab>
      <Tab
        isActive={activeFilter === 'unnamed'}
        onClick={() => onFilterChange('unnamed')}
      >
        <Trans>Unnamed</Trans>
        <Count>{unnamedCount}</Count>
      </Tab>
    </TabsContainer>
  );
};
